import { Icon, type IconName } from "./icons";

export type BrandIconName =
  | "bookmark"
  | "bookshelf"
  | "create"
  | "home"
  | "ip"
  | "message"
  | "notification"
  | "novel"
  | "profile"
  | "reader"
  | "search"
  | "translation";

const brandIconRegistry: Record<BrandIconName, IconName> = {
  bookmark: "bookmark",
  bookshelf: "bookshelf",
  create: "create",
  home: "home",
  ip: "discover",
  message: "mail",
  notification: "bell",
  novel: "novel",
  profile: "account",
  reader: "request",
  search: "search",
  translation: "translation"
};

export function BrandIcon({
  name,
  className = ""
}: {
  name: BrandIconName;
  className?: string;
}) {
  return (
    <Icon
      className={`brand-icon ${className}`.trim()}
      name={brandIconRegistry[name]}
    />
  );
}

export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return (
    <span
      aria-hidden="true"
      className={`brand-logo ${compact ? "is-compact" : ""}`.trim()}
    >
      <svg
        className="brand-logo-mark"
        viewBox="16.06789 18.844778 32.64379 26.298267"
      >
        <path
          d="M 21.843465 20.907434 C 23.517017109 26.494062255 30.716217723 23.778742623 34.577422 22.631512 C 35.373004779 22.395130586 36.132783669 21.909169432 36.965311 21.850016 A 6 6 0 0 1 43.014968 25.745433 C 43.340556488 26.621837969 43.077227 27.664964466 43.077227 28.586297 L 43.077227 40.047813 L 32.706289 40.047813 C 35.031996566 37.464665404 37.746848844 32.868248541 34.285375 29.99086 C 31.333073525 27.53672664 25.375789024 27.854738571 22.895192 30.885409 C 22.089512718 31.869747992 21.83596497 33.227030896 21.789953 34.46586 L 19.71746 34.46586 L 19.71746 20.907434 L 21.843465 20.907434 Z M 44.742188 40.501172 L 44.742188 42.46172 L 16.06789 42.46172 L 16.06789 40.501172 L 44.742188 40.501172 Z M 46.807461 22.021527 L 46.807461 32.803086 L 44.742188 32.803086 L 44.742188 30.89441 L 43.566953 29.544147 L 43.566953 25.423582 L 44.742188 24.086937 L 44.742188 22.021527 L 46.807461 22.021527 Z M 19.15027 34.453008 L 17.01669 34.453008 L 17.01669 20.907434 L 19.15027 20.907434 L 19.15027 34.453008 Z M 48.040391 27.387903 L 48.075664 27.403952 L 48.075664 26.965824 L 48.71168 26.965824 L 48.71168 45.143045 L 19.189957 45.143045 A 25 25 0 0 1 19.201513 42.947629 L 19.27832 42.933125 L 19.71746 42.933125 L 19.71746 44.604102 L 48.075664 44.604102 L 48.075664 27.471246 L 48.07211 27.448386 C 47.897984829 27.524346294 47.881652688 28.20003747 47.814605 28.39135 A 2.354531 2.354531 0 0 1 47.35789 29.17066 C 47.337383 28.06529 47.32371 26.656102 47.361992 25.559563 C 47.794844 25.888343 47.937032 26.925027 48.040391 27.387903 Z M 36.403274 19.800988 A 1.637923 1.637923 0 0 1 37.197461 19.04934 A 1.371931 1.371931 0 0 1 39.120638 20.421592 C 38.971498161 22.146362961 36.719226301 21.941277316 36.325235 20.413906 C 32.763209729 21.499558127 29.148253021 21.987261445 25.475291 21.16532 A 28.579362 28.579362 0 0 1 21.817892 20.08617 C 21.315443522 19.900662901 20.447109064 19.319626135 19.910402 19.372201 C 19.544133171 19.40808004 19.69144537 20.664458635 19.71746 20.907434 L 19.15027 20.907434 C 19.148005477 20.329243028 18.923663623 19.015186073 19.740276 18.862508 C 20.383406459 18.742265004 21.175128129 19.265089025 21.758987 19.490736 A 26.478423 26.478423 0 0 0 25.260034 20.571993 A 18.936772 18.936772 0 0 0 36.403274 19.800988 Z M 20.321895 34.650977 L 20.321895 35.998203 L 19.71746 35.998203 L 19.71746 37.351992 L 19.573387 37.39547 C 19.259810649 38.167912411 19.645034674 39.190353622 19.459335 40.001328 C 19.32382 39.821406 19.444079 37.543672 19.308044 37.374961 L 19.213142 37.380106 A 5.236943 5.236943 0 0 1 19.180217 36.00354 L 18.57132 36.00354 L 18.57132 34.650977 L 20.321895 34.650977 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>
      {compact ? null : <span className="brand-logo-word">loomua</span>}
    </span>
  );
}
